module.exports = __webpack_public_path__ + "img/doit-logo.3358f22b.png";